<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-form-item
        label="装货时间"
        prop="time"
        style="margin-right:15px"
      >
        <el-date-picker
          v-model="form.time"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="选择"
        />
      </el-form-item>
      <el-form-item
        label="货物吨位"
        prop="weight"
        style="margin-right:15px"
      >
        <el-input
          v-model="form.weight"
          @input="(value)=>formFormatter.isFloor3(value,oldValue,form,'weight')"
        >
          <template slot="append">
            吨
          </template>
        </el-input>
      </el-form-item>
      <el-row v-if="form.coalUnit!=0">
        <el-form-item
          label="货物数量"
          prop="quantity"
          style="margin-right:15px"
        >
          <el-input
            v-model="form.quantity"
            @input="(value)=>form.coalUnitName=='件'?formFormatter.isInteger(value,oldValue,form,'quantity'):formFormatter.isFloor3(value,oldValue,form,'quantity')"
          >
            <template slot="append">
              {{ form.coalUnitName }}
            </template>
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item
          label="装货单据2"
          prop="imgUrl"
          style="margin-right:15px"
        >
          <!--:on-preview="handlePictureCardPreview"-->
          <el-upload
            ref="upload"
            :headers="headers"
            :action="uploadUrl"
            list-type="picture-card"
            :before-upload="beforeImgUpload"
            :on-success="handleImgSuccess"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus" />
          </el-upload>
          <el-dialog :visible.sync="showImageFlag">
            <img
              width="100%"
              :src="showImageUrl"
              alt
            >
          </el-dialog>
        </el-form-item>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import { orderDetailfill } from "@/api/transport";
import { getToken } from '@/utils/auth';
export default {
  data() {
    return {
      uploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
       headers:{
        Authorization:'Bearer ' + getToken(),
        deviceId:'0000000000'
       },
      pageType: "load",
      image: [],
      showImageUrl: "",
      showImageFlag: false,
      form: {
        time: "",
        weight: "",
        quantity: "",
        imgUrl: ""
      },
      rules: {
        time: [{ required: true, message: "请选择装货时间", trigger: "blur" }],
        weight: [
          { required: true, message: "请输入货物吨位", trigger: "blur" },
          { min: 0, max: 20, message: '长度不超过20个字符', trigger: 'blur' },
        ],
        quantity: [
          { required: true, message: "请输入货物数量", trigger: "blur" },
          { min: 0, max: 20, message: '长度不超过20个字符', trigger: 'blur' },
        ],
        imgUrl: [{ required: true, message: "请上传装货单据", trigger: "blur" }]
      }
    };
  },
  created() {},
  methods: {
    init(entity) {
      this.form.code = entity.code;
      this.form.time = entity.time;
      this.form.weight = entity.weight;
      this.form.quantity = entity.quantity;
      this.form.imgUrl = entity.imgUrl;
      this.form.coalUnit = entity.coalUnit;
      this.form.coalUnitName = entity.coalUnitName;
      this.$refs.upload.clearFiles();
    },
    funcSubmit() {
      if (this.image && this.image.length > 0) {
        this.form.imgUrl = this.image.join(",");
      } else {
        this.form.imgUrl = "";
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          const rLoading = this.openLoading();
          const data = this.form;
          orderDetailfill(data)
            .then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherSubmitMethod", this.pageType);
              rLoading.close();
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", this.pageType);
    },
    handleImgSuccess(res, file) {
      if(res.status==500){
        this.$message.error(res.msg)
      } else {
        this.image.push(res.data);
      }
    },
    handleRemove(file, fileList) {
      this.image.splice(this.image.indexOf(file.response.data), 1);
    },
    beforeImgUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/bmp" ||
        file.type === "image/png";
      const isLtnM = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,BMP,PNG 格式!");
        return false
      }
      if (!isLtnM) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false
      }
      
      // 获取token值，实时获取
      this.headers.Authorization = 'Bearer ' + getToken()
      return isJPG && isLtnM;
    },
    handlePictureCardPreview(file) {
      this.showImageUrl = file.url;
      this.showImageFlag = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
